<template>
  <div class="container-fluid pt-0">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>

    <DeleteModal
      :show="deleteModal"
      @close="closeDeleteModal()"
      @submit="doPause"
      :name="$t('device_transmission')"
      :msg="$t('pause_text')"
      :action="$t('pause')"
      :isDevicesRoute="true"
      buttonClass="btn-primary"
    />

    <ConfirmModal
      :msg="$t('start_text')"
      :show="showConfirm"
      @close="closeConfirm()"
      @submit="doStart"
      :heading="$t('start_transmission')"
      :btnTxt="$t('yes_start')"
      is-yellow
      msgWidth="msg_width"
    />

    <SuccessModal
      :show="showSuccessPopup"
      @close="closeSuccess"
      :msg="successMsg"
      :heading="successHeading"
      msgWidth="msg_width"
    />

    <ConfirmModal
      :msg="$t('turn_off_flight_mode_msg')"
      :show="showTurnOffFlightMode"
      @close="closeTurnOffFlightMode"
      @submit="doTurnOffFlightMode"
      :heading="$t('turn_off_flight_mode')"
      :btnTxt="$t('yes_turn_off')"
      is-yellow
      msgWidth="msg_width"
    />

    <flight-mode-modal
      :show="showFlightModeModal"
      :onCancel="closeFlightModeModal"
      @flightMode="flightModeSuccess"
      @isLoading="isLoading = $event"
      v-if="showFlightModeModal"
    />

    <div
      v-if="
        singledevice && singledevice.status === 'critical' && singledevice.stat
      "
    >
      <div :key="index" v-for="(note, index) in singledevice.stat.notes">
        <div
          v-if="note"
          class="alert alert-danger alert-dismissible fade show margin-bottom-1x p-b-20"
        >
          <div style="display: flex" class="align-items-center">
            <div class="mr-3">
              <i class="font-24 icon-bell"></i>
            </div>
            <div>
              <h5 class="alert-close mb-0">{{ $t("alert") }}</h5>
              <div class="alert-close mb-0">
                {{ note.replace(/�/g, "°") }}. {{ $t("read-on") }}
                {{ getDate(singledevice.stat.deviceTimeStamp) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Flight Mode Message -->
    <div class="flight-mode-msg" v-if="isOnFlightMode">
      <p class="gray6 font-14">
        <span class="font-weight-bold">{{ $t("flight_mode") }}:</span>
        {{ singledevice.flightMode.message }}
      </p>
      <p class="gray5 font-12">
        {{ $t("start-date") }} -
        {{ getFlightDate(singledevice.flightMode.startDate) }}
        {{ $t("end-date") }} -
        {{ getFlightDate(singledevice.flightMode.endDate) }}
      </p>
    </div>
    <!-- New -->
    <div class="row device-info-row">
      <div class="col-12 col-md-6 col-xl-4 mb-4">
        <div class="card h-100 device-info-card">
          <div class="card-body">
            <h4 class="mb-1 mx-2 text-capitalize">
              {{ singledevice.settings.name }}
            </h4>
            <!-- <p class="gray3 font-12 mx-2">
              {{ $t("dev_type") }}:
              <strong class="text-dark">{{ singledevice.type }}</strong>
            </p> -->
            <div
              class="row mx-2 py-2"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div class="col-8 pl-0 text-muted mb-0">
                {{ $t("dev_type") }}:
              </div>
              <div class="col-4 font-medium text-right mb-0 text-capitalize">
                {{ singledevice.type }}
              </div>
            </div>

            <div
              class="row mx-2 py-2"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div class="col-8 pl-0 text-muted mb-0">{{ $t("dev-tag") }}</div>
              <div class="col-4 font-medium text-right mb-0">
                {{ singledevice.deviceTag }}
              </div>
            </div>
            <div
              class="row mx-2 py-2"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div class="col-8 pl-0 text-muted mb-0">
                {{ $t("device") }} {{ $t("imei") }}
              </div>
              <div class="col-4 font-medium text-right mb-0">
                {{ singledevice.imei }}
              </div>
            </div>

            <div
              class="row mx-2 py-2"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
              v-if="!singledevice.isDecommissioned && !hasStartAndEnd"
            >
              <div class="col-8 pl-0 text-muted mb-0">
                <p class="pl-0 text-muted mb-0">
                  {{ $t("device_transmission") }}
                </p>
              </div>
              <div class="col-4 font-medium text-right mb-0">
                <toggle-button
                  :value="toggleValue"
                  @change="handleTransmission"
                  :color="'#6282C4'"
                  sync
                />
              </div>
            </div>
            <div
              class="row mx-2 py-2"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
              v-if="!singledevice.isDecommissioned && !hasStartAndEnd"
            >
              <div class="col-8 pl-0 text-muted mb-0">
                <p class="pl-0 text-muted mb-0">{{ $t("flight_mode") }}</p>
              </div>
              <div class="col-4 font-medium text-right mb-0">
                <toggle-button
                  :value="isOnFlightMode"
                  @change="handleToggleFlightMode"
                  :disabled="disableToggleBtn"
                  :color="'#6282C4'"
                  sync
                />
              </div>
            </div>

            <!-- <div
              class="row mx-2 py-2 mt-5 justify-content-between col-gap-1 align-items-center"
            >
              <p class="pl-0 text-muted mb-0">{{$t("device_transmission")}}</p>
              <toggle-button
                :value="toggleValue"
                @change="handleTransmission"
                :color="'#6282C4'"
                sync
              />
            </div> -->
            <!-- <div
              class="row mx-2 py-2"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div class="col-8 pl-0 text-muted mb-0 text-capitalize">
                {{ $t("group") }}
              </div>
              <div class="col-4 font-medium text-right mb-0">
                {{ group }}
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 col-xl-4 mb-4">
        <div class="card device-info-card" style="overflow-y: auto; height: 100%">
          <div class="card-body">
            <div class="row py-2 px-2">
              <div
                class="col-12 align-items-center mb-2"
                style="display: flex"
                v-if="singledevice.type.toLowerCase() !== 'loctrack'"
              >
                <img
                  src="../../assets/images/snowflake.png"
                  alt=""
                  style="width: 28px; height: 32px"
                />
                <h2
                  class="mb-0 text-primary font-24 ml-2"
                  v-if="singledevice.type !== 'gateway' && singledevice.stat"
                >
                  {{ singledevice.stat.temperature }}<sup>°</sup>C
                </h2>
                <h2 v-else class="text-primary mb-0">-<sup>°</sup>C</h2>
              </div>
              <div class="col-12 mb-0 last-read-line">
                <p
                  style="font-size: 0.9rem"
                  class="gray3 mb-0 font-12"
                  v-if="singledevice.stat && singledevice.stat.deviceTimeStamp"
                >
                  {{ $t("last-read") }}
                </p>
                <p
                  v-if="singledevice.stat && singledevice.stat.deviceTimeStamp"
                  style="font-size: 0.9rem"
                  class="gray3 mb-0 ml-1 font-12"
                >
                  {{ getDate(singledevice.stat.deviceTimeStamp) }}
                </p>
                <p v-else style="font-size: 0.9rem" class="gray3 mb-0">
                  {{ $t("no-read") }}
                </p>
              </div>
            </div>

            <div
              class="row mx-2 py-2"
              v-if="
                (singledevice.type.toLowerCase() === 'mote' ||
                  singledevice.type.toLowerCase() === 'lora' ||
                  singledevice.type.toLowerCase() === 'glog5' ||
                  singledevice.type.toLowerCase() === 'gps-vt') &&
                singledevice.stat
              "
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div class="col-8 pl-0 text-muted mb-0">{{ $t("humid") }}</div>
              <div class="col-4 font-medium text-right mb-0">
                <span>{{ singledevice.stat.humidity }}%</span>
              </div>
            </div>

            <div
              class="row mx-2 py-2"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div class="col-8 pl-0 text-muted mb-0">{{ $t("batt") }}</div>
              <div class="col-4 font-medium text-right mb-0">
                <span
                  v-if="singledevice.stat && singledevice.stat.battery < 0"
                  class="red-text"
                  >{{ $t("emp") }}</span
                >
                <span
                  v-else-if="
                    singledevice.stat && singledevice.stat.battery >= 100
                  "
                  >100%</span
                >
                <span v-else-if="singledevice.stat && singledevice.stat.battery"
                  >{{ singledevice.stat.battery }}%</span
                >
                <span v-if="singledevice.charging === true" class="green-text"
                  ><i class="mdi mdi-battery-charging"></i
                ></span>
              </div>
            </div>

            <div
              class="row mx-2 py-2"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
              v-if="singledevice.type.toLowerCase() !== 'loctrack'"
            >
              <div class="col-8 pl-0 text-muted mb-0">{{ $t("min-temp") }}</div>
              <div class="col-4 font-medium text-right mb-0">
                <span
                  >{{ singledevice.settings.minTemperature }}<sup>°</sup>C</span
                >
              </div>
            </div>

            <div
              class="row mx-2 py-2"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
              v-if="singledevice.type.toLowerCase() !== 'loctrack'"
            >
              <div class="col-8 pl-0 text-muted mb-0">{{ $t("max-temp") }}</div>
              <div class="col-4 font-medium text-right mb-0">
                <span
                  >{{ singledevice.settings.maxTemperature }}<sup>°</sup>C</span
                >
              </div>
            </div>

            <div
              class="row mx-2 py-2"
              v-if="singledevice.type.toLowerCase() === 'box'"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div class="col-8 pl-0 text-muted mb-0">
                {{ $t("set-point") }}
              </div>
              <div class="col-4 font-medium text-right mb-0">
                <span>{{ singledevice.settings.preset }}<sup>°</sup>C</span>
              </div>
            </div>

            <div
              class="row mx-2 py-2"
              v-if="
                singledevice.type.toLowerCase() === 'mote' ||
                singledevice.type.toLowerCase() === 'lora' ||
                singledevice.type.toLowerCase() === 'glog5' ||
                singledevice.type.toLowerCase() === 'gps-vt'
              "
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div class="col-8 pl-0 text-muted mb-0">
                {{ $t("min-humid") }}
              </div>
              <div class="col-4 font-medium text-right mb-0">
                <span>{{ singledevice.settings.minHumidity }}%</span>
              </div>
            </div>

            <div
              class="row mx-2 py-2"
              v-if="
                singledevice.type.toLowerCase() === 'mote' ||
                singledevice.type.toLowerCase() === 'lora' ||
                singledevice.type.toLowerCase() === 'glog5' ||
                singledevice.type.toLowerCase() === 'gps-vt'
              "
            >
              <div class="col-8 pl-0 text-muted mb-0">
                {{ $t("max-humid") }}
              </div>
              <div class="col-4 font-medium text-right mb-0">
                <span>{{ singledevice.settings.maxHumidity }}%</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="col-12 col-md-12 col-xl-4 mb-4"
        v-if="singledevice.type !== 'lora' && singledevice.type !== 'glog5'"
      >
        <div class="card device-info-card" style="overflow-y: auto; height: 100%">
          <div class="card-body">
            <div class="row py-2 px-2">
              <div class="col-12 align-items-center mb-2" style="display: flex">
                <!-- <icon-location-filled /> -->
                <img
                  src="../../assets/images/carbon_location-filled.png"
                  alt=""
                  style="height: 28px"
                />
                <h2 class="mb-0 text-primary text-capitalize ml-1 font-24">
                  {{ $t("location") }}
                </h2>
              </div>
              <div class="col-12 mb-0 last-read-line">
                <p
                  style="font-size: 0.9rem"
                  class="gray3 mb-0 font-12"
                  v-if="
                    singledevice.lastValidLocation &&
                    singledevice.lastValidLocation.deviceTimeStamp
                  "
                >
                  {{ $t("last_valid_loca") }}
                </p>
                <p
                  v-if="
                    singledevice.lastValidLocation &&
                    singledevice.lastValidLocation.deviceTimeStamp
                  "
                  style="font-size: 0.9rem"
                  class="gray3 mb-0 ml-1 font-12"
                >
                  {{ getDate(singledevice.lastValidLocation.deviceTimeStamp) }}
                </p>
                <p v-else style="font-size: 0.9rem" class="gray3 mb-0">
                  {{ $t("no-read") }}
                </p>
              </div>
            </div>

            <div
              class="row mx-2 py-2"
              v-if="
                (singledevice.type.toLowerCase() === 'mote' ||
                  singledevice.type.toLowerCase() === 'lora' ||
                  singledevice.type.toLowerCase() === 'glog5' ||
                  singledevice.type.toLowerCase() === 'gps-vt') &&
                singledevice.lastValidLocation
              "
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div class="col-8 pl-0 text-muted mb-0">
                {{ $t("longitude") }}
              </div>
              <div class="col-4 font-medium text-right mb-0">
                <span>{{ singledevice.lastValidLocation.longitude }}</span>
              </div>
            </div>

            <div
              class="row mx-2 py-2"
              v-if="
                (singledevice.type.toLowerCase() === 'mote' ||
                  singledevice.type.toLowerCase() === 'lora' ||
                  singledevice.type.toLowerCase() === 'glog5' ||
                  singledevice.type.toLowerCase() === 'gps-vt') &&
                singledevice.lastValidLocation
              "
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div class="col-8 pl-0 text-muted mb-0">{{ $t("latitude") }}</div>
              <div class="col-4 font-medium text-right mb-0">
                <span v-if="singledevice.lastValidLocation.latitude">{{
                  singledevice.lastValidLocation.latitude
                }}</span>
              </div>
            </div>

            <!-- <div
              class="row mx-2 py-2"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div class="col-8 pl-0 text-muted mb-0">{{ $t("location") }}</div>
              <div
                class="col-4 font-medium text-right mb-0"
                v-if="singledevice.settings.location"
              >
                {{ singledevice.settings.location }}
              </div>
            </div> -->

            <div class="col-12">
              <div
                class="d-flex align-items-center mt-3 text-primary cursor-pointer"
                @click.prevent="
                  viewonMap(
                    singledevice.lastValidLocation.latitude,
                    singledevice.lastValidLocation.longitude,
                  )
                "
              >
                <p class="mb-0">{{ $t("view_on_map") }}</p>
                <img
                  src="../../assets/images/solar_arrow-up-outline.png"
                  alt=""
                  class="ml-1"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Error Message for Transmission -->
    <div
      class="row align-items-center paused-transmission-container p-3 mx-1 mb-4"
      v-if="showTransmissionErrMsg"
    >
      <div class="col-12 col-sm-6 mb-0">
        <div class="d-flex">
          <IconCaution class="mr-2" />
          <div>
            <p class="error-msg mb-1">{{ $t("transmission_paused") }}</p>
            <p class="mb-0 error-msg">
              {{ $t("transmission_paused_text") }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-6 mb-0 mt-3 mt-sm-0 text-sm-right">
        <button
          class="btn btn-primary start-transmission-btn"
          @click="
            startTransmission(singledevice.id, singledevice.settings.name)
          "
        >
          {{ $t("start_transmission") }}
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-lg-7">
        <div class="card mb-4">
          <div class="card-body chart-card-body">
            <div
              class="d-flex justify-content-space-around col-12 col-md-10 col-lg-8 col-xl-6 mx-auto px-0"
              v-if="chartType === 'old' && singledevice.type !== 'gateway'"
            >
              <div class="btn-container">
                <button
                  @click="
                    tempGraph = true;
                    humiGraph = false;
                  "
                  :disabled="tempGraph == true"
                  id="graphselect"
                >
                  {{ $t("temp") }}
                </button>
              </div>
              <div class="btn-container">
                <button
                  @click="
                    tempGraph = false;
                    humiGraph = true;
                  "
                  :disabled="tempGraph == false"
                  id="graphselect"
                >
                  {{ $t("humid") }}
                </button>
              </div>
            </div>
            <div>
              <MultiAxisChart
                :tempGraph="tempGraph"
                :humiGraph="humiGraph"
                :stats="devicehistoryChart"
                :deviceName="singledevice.settings.name"
                v-if="chartType === 'new'"
                :hasLight="hasLight"
                :hasTemp2="hasTemp2"
              />
              <CombinedChart
                :tempGraph="tempGraph"
                :humiGraph="humiGraph"
                :stats="devicehistoryChart"
                v-if="chartType === 'old'"
                :hasLight="hasLight"
                :hasTemp2="hasTemp2"
              />
              <Pagination
                :pageCount="pageCount"
                :data="devicehistoryChart"
                :sizeperpage="chartLimit"
                :pageNumber="paginationPageNo"
                :pages="pages"
                @goToLastPage="goToLastPage"
                @nextPage="nextPage"
                @goToFirstPage="goToFirstPage"
                @prevPage="prevPage"
                @onchange="onchange"
                :rowOption="'chart'"
                :customEmitKey="customEmitKey"
                @handlePageChangeChart="handlePageChange"
                v-if="pageCount > 1"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-5">
        <div
          class="card mb-4 map-card"
          ref="mapContent"
          id="mapCont"
        >
          <div class="card-body" id="map-image">
            <DeviceRoutes2
              :mapPoints="mapPoints"
              :lastValidLocation="lastValidLocation"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body history-table-body">
        <CombinedTable
          :stats="devicehistory.data"
          :type="singledevice.type.toLowerCase()"
          :paginationMeta="devicehistory.meta"
          :hasTemp2="hasTemp2"
          @pageChange="(params) => $emit('pageChange', params)"
        />
      </div>
    </div>
  </div>
</template>

<script
  src="https://maps.googleapis.com/maps/api/js?key=AIzaSyB41DRUbKWJHPxaFjMAwdrzWzbVKartNGg&callback=initMap&v=weekly"
  defer
></script>
<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";
import moment from "moment";
// import CombinedChart from "../../components/Devices/CombinedChart";
import loadGoogleMapsApi from "load-google-maps-api";
import DeviceRoutes2 from "../../components/Devices/DeviceRoutes2";
import DeviceRoutes from "../../components/Devices/DeviceRoutes";
import CombinedTable from "../../components/Devices/CombinedTable";
import IconLocationFilled from "../../components/Iconsvg/IconLocationFilled.vue";
import { ToggleButton } from "vue-js-toggle-button";
import DeleteModal from "../../views/Modals/DeleteModal";
import ConfirmModal from "../../views/Modals/ConfirmModal";
import SuccessModal from "../../views/Modals/SuccessModal";
import IconCaution from "../../components/Iconsvg/IconCaution.vue";
import FlightModeModal from "../Modals/FlightModeModal.vue";
import tableMixin from "../../mixins/tableMixinWithBackend";
import Pagination from "../../components/PaginationNew.vue";

Vue.component("ToggleButton", ToggleButton);

export default {
  name: "DeviceDetails",
  mixins: [tableMixin],
  props: {
    devicehistoryChart: {
      type: Array,
      default: () => [],
    },
    deviceHistoryChartMeta: {
      type: Object,
      default: () => {},
    },
    chartLimit: {
      type: Number,
      default: 1000,
    },
    chartPageNumber: {
      type: Number,
      default: 1,
    },
    mapPoints: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tempGraph: true,
      humiGraph: false,
      isLoading: false,
      fullPage: true,
      lastreaddate: "",
      datecreated: "",
      apiKey: "585543c980c244aa998891066c7fe492",
      license: "",
      mssg: "",
      Errormssg: "",
      deviceOn: true,
      rate: "",
      location: "",
      isRouteOne: false,
      toggleValue: false,
      deleteModal: false,
      showSuccessPopup: false,
      showConfirm: false,
      successMsg: "",
      successHeading: "",
      deviceId: "",
      deviceName: "",
      showFlightModeModal: false,
      // isOnFlightMode: false,
      showTurnOffFlightMode: false,
      customEmitKey: "handlePageChangeChart",
      pageNumber: this.chartPageNumber,
      sizeperpage: this.chartLimit,
    };
  },
  components: {
    Loading,
    CombinedChart: () =>
      import(
        /* webpackPrefetch: true */ "../../components/Devices/CombinedChart"
      ),
    DevieMap: () =>
      import(
        /* webpackPrefetch: true */ "../../components/Devices/AllDevicesMap.vue"
      ),
    MultiAxisChart: () =>
      import(
        /* webpackPrefetch: true */ "../../components/Charts/MultiAxisChart"
      ),
    DeviceRoutes,
    DeviceRoutes2,
    CombinedTable,
    IconLocationFilled,
    DeleteModal,
    ConfirmModal,
    SuccessModal,
    IconCaution,
    FlightModeModal,
    Pagination,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  computed: {
    ...mapGetters([
      "singledevice",
      "token",
      "profile",
      "lastPageData",
      "groups",
      "devicehistoryMapPoints",
      "devicehistory",
      "selectedSession",
    ]),
    chartType() {
      return this.profile.company.chartType || "old";
    },
    disableToggleBtn() {
      const today = new Date();
      const { flightMode } = this.singledevice;

      if (!flightMode?.startDate || !flightMode?.endDate) return false;

      const dateStarted = new Date(flightMode.startDate);
      const dateEnded = new Date(flightMode.endDate);
      if (today >= dateStarted && today <= dateEnded) return true;

      return false;
    },
    getSignalStrength() {
      let val =
        this.singledevice.stats[this.singledevice.stats.length - 1].moteAddress
          .signalStrength;
      function between(x, min, max) {
        return x >= min && x <= max;
      }
      let strength;
      if (between(val, -120, -95.0)) {
        strength = "Extremely Bad";
      }
      if (between(val, -95.01, -85.0)) {
        strength = "Bad";
      }
      if (between(val, -85.01, -75.0)) {
        strength = "Average";
      }
      if (between(val, -75.01, -65.0)) {
        strength = "Good";
      }
      if (between(val, -65.01, -55.0)) {
        strength = "Very Good";
      }
      if (between(val, -55.01, 0.0)) {
        strength = "Excellent";
      }

      return strength;
    },
    mapDevice() {
      const lastPosition =
        this.singledevice.stats[this.singledevice.stats.length - 1];
      let devices = [
        {
          stats: {
            latitude: lastPosition.latitude,
            longitude: lastPosition.longitude,
          },
          id: this.singledevice.id,
          settings: this.singledevice?.settings,
          type: this.singledevice.type,
        },
      ];
      return devices;
    },
    group() {
      const group = this.groups.filter(
        ({ id }) => id === this.singledevice.group,
      );
      if (group.length > 0) {
        return group[0].name;
      } else return "NIL";
    },
    showChart() {
      return (
        this.singledevice &&
        (this.singledevice.type == "mote" ||
          this.singledevice.type.toLowerCase() === "lora" ||
          this.singledevice.type.toLowerCase() === "glog5" ||
          this.singledevice.type.toLowerCase() === "gps-vt")
      );
    },
    showTransmissionErrMsg() {
      return (
        (this.singledevice &&
          this.singledevice.isTransmissionEnabled === false &&
          this.singledevice.type.toLowerCase() !== "gateway") ||
        false
      );
    },
    isOnFlightMode() {
      return this.singledevice?.flightMode?.isEnabled || false;
    },
    flightModeMsg() {
      this.singledevice?.flightMode?.isEnabled;
    },
    paginationMeta() {
      return this.deviceHistoryChartMeta;
    },
    paginationPageNo() {
      return this.deviceHistoryChartMeta?.currentPage || this.chartPageNumber;
    },
    hasLight() {
      return this.singledevice?.hasLight || false;
    },
    hasTemp2() {
      return this.singledevice?.hasTemp2 || false;
    },
    lastValidLocation() {
      if (
        !this.singledevice?.lastValidLocation?.latitude ||
        !this.singledevice?.lastValidLocation?.longitude
      )
        return null;
      const payload = {
        latitude: this.singledevice.lastValidLocation.latitude,
        longitude: this.singledevice.lastValidLocation.longitude,
      };
      return payload;
    },
    hasStartAndEnd() {
      return this.startDate && this.endDate;
    },
    startDate() {
      return this.selectedSession?.startDate || null;
    },
    endDate() {
      return this.selectedSession?.endDate || null;
    },
  },
  methods: {
    ...mapActions([
      "updatePageNumber",
      "getDeviceHistory",
      "updateDevice",
      "fetchDeviceDetails",
      "updateFlightMode",
      "resetDeviceHistory",
      "updateFlightModeDirect",
    ]),
    handleTransmission({ value }) {
      this.toggleValue = value;
      if (value) {
        this.startTransmission(
          this.singledevice.id,
          this.singledevice.settings.name,
        );
      } else {
        this.showDeleteModal(
          this.singledevice.id,
          this.singledevice.settings.name,
        );
      }
    },
    noDirection() {
      this.isRouteOne = true;
    },
    closeModal() {
      this.isOpen = false;
    },
    getDate(date) {
      return moment(date).format("ddd, MMM Do YYYY, hh:mm a");
    },
    getAddress() {
      loadGoogleMapsApi({
        key: process.env.VUE_APP_GOOGLE_API_KEY,
        libraries: ["places", "drawing", "geometry"],
      }).then(async () => {
        const lastValidLocation = this.singledevice.lastValidLocation;
        this.geocode(lastValidLocation.latitude, lastValidLocation.longitude);
      });
    },
    geocode(lat, lng) {
      const { google } = window;
      const geocoder = new google.maps.Geocoder();
      geocoder
        .geocode({ location: { lat, lng } })
        .then((response) => {
          this.location = response.results[0].address_components[1].short_name;
        })
        .catch((e) => {
          console.log(e);
          // alert(e.message);
        });
    },
    handleParams(params) {
      this.$emit("params", params);
    },
    viewonMap(lat, lng) {
      window.open(`https://google.com/maps/search/${lat},${lng}`, "_blank");
    },
    showDeleteModal(id, name) {
      this.deviceId = id;
      this.deviceName = name;
      this.deleteModal = true;
    },
    doPause() {
      this.isLoading = true;
      this.updateDevice({
        device_id: this.deviceId,
        deviceupdate: {
          name: this.deviceName,
          isTransmissionEnabled: false,
        },
      })
        .then(() => {
          this.deleteModal = false;
          this.successHeading = this.$t("pause_heading");
          this.successMsg = this.$t("pause_msg");
          this.showSuccess();
          this.fetchDevice();
        })
        .catch((error) => {
          this.isLoading = false;
        });
    },
    doStart() {
      this.isLoading = true;
      this.updateDevice({
        device_id: this.deviceId,
        deviceupdate: {
          name: this.deviceName,
          isTransmissionEnabled: true,
        },
      })
        .then(() => {
          this.successMsg = this.$t("start_msg");
          this.successHeading = this.$t("start_heading");
          this.showConfirm = false;
          this.showSuccess();
          this.fetchDevice();
        })
        .catch((error) => {
          this.isLoading = false;
        });
    },
    startTransmission(id, name) {
      this.deviceId = id;
      this.deviceName = name;
      this.showConfirm = true;
    },
    showSuccess() {
      this.showSuccessPopup = true;
    },
    closeSuccess() {
      this.showSuccessPopup = false;
      this.deviceId = "";
      this.deviceName = "";
    },
    fetchDevice() {
      this.isLoading = true;
      this.fetchDeviceDetails({ device_id: this.$route.params.device_id })
        .then(() => {
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response) {
            //console.log(error.response);
            this.$router.push("/404");
          }
        });
    },
    closeDeleteModal() {
      this.deleteModal = false;
      this.toggleValue = this.singledevice.isTransmissionEnabled ?? true;
    },
    closeConfirm() {
      this.showConfirm = false;
      this.toggleValue = this.singledevice.isTransmissionEnabled ?? true;
    },
    handleToggleFlightMode({ value }) {
      if (value) {
        this.showFlightModeModal = true;
      } else {
        this.showTurnOffFlightMode = true;
      }
    },
    closeFlightModeModal() {
      this.showFlightModeModal = false;
    },
    flightModeSuccess() {
      this.showFlightModeModal = false;
      this.showSuccessPopup = true;
      this.successMsg = this.$t("flight_mode_on_msg");
      this.successHeading = this.$t("flight_mode_on_heading");
      this.fetchDevice();
    },
    getFlightDate(date) {
      return moment(date).format("M/D/YYYY h:mmA");
    },
    closeTurnOffFlightMode() {
      this.showTurnOffFlightMode = false;
    },
    doTurnOffFlightMode() {
      if (this.singledevice.flightMode.type === "direct") {
        const { carrierCode, flightNumber, scheduledDepartureDate, schedule } =
          this.singledevice.flightMode;
        const payload = {
          carrierCode,
          flightNumber,
          scheduledDepartureDate,
          enableFlightMode: false,
          schedule,
        };
        this.isLoading = true;
        this.updateFlightModeDirect({
          device_id: this.$route.params.device_id,
          flightMode: payload,
        })
          .then(() => {
            this.showTurnOffFlightMode = false;
            this.showSuccessPopup = true;
            this.successMsg = this.$t("flight_mode_off_msg");
            this.successHeading = this.$t("flight_mode_off_heading");
            this.fetchDevice();
          })
          .catch(() => {
            this.isLoading = false;
          });
      } else {
        const payload = {
          startDate: this.singledevice.flightMode.startDate,
          endDate: this.singledevice.flightMode.endDate,
          enableFlightMode: false,
        };
        this.isLoading = true;
        this.updateFlightMode({
          device_id: this.$route.params.device_id,
          flightMode: payload,
        }).then(() => {
          this.showTurnOffFlightMode = false;
          this.showSuccessPopup = true;
          this.successMsg = this.$t("flight_mode_off_msg");
          this.successHeading = this.$t("flight_mode_off_heading");
          this.fetchDevice();
        });
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name !== "Devices" &&
      to.name != "DeviceExcursions" &&
      to.name != "DeviceSettings" &&
      to.name !== "DeviceReport"
    ) {
      this.updatePageNumber({
        lastPageNumber: 1,
        lastPage: ``,
        lastPageName: "",
      });
    }
    this.updatePageNumber({
      ...this.lastPageData,
      lastPageName: "",
    });
    next();
  },
  mounted() {
    this.updatePageNumber({
      ...this.lastPageData,
      lastPageName: "device",
    });
    this.fetchDevice();
  },
  watch: {
    singledevice: {
      handler(val) {
        this.toggleValue = val?.isTransmissionEnabled ?? true;
      },
      deep: true,
      immediate: true,
    },
  },
  beforeDestroy() {
    this.resetDeviceHistory();
  },
};
</script>

<style scoped>
.btn-container {
  display: flex;
  justify-content: center;
  width: 50%;
}
#graphselect {
  background-color: inherit;
  border: none;
  color: #213e7a;
  padding: 7px 25px;
  border-radius: 30px;
  outline: none;
}
#graphselect:hover {
  background-color: #213e7a;
  color: white;
}
#graphselect:disabled,
#graphselect[disabled] {
  background-color: #dee2eb;
  color: #213e7a;
}
.green-text {
  color: #213e7a;
}

.succeed {
  background: #ffe6cc;
  padding: 15px 15px 7px;
  border: 1px solid #f0ac66;
  margin-bottom: 2rem;
  border-radius: 3px;
}
.succeed p {
  color: #f0ac66;
}

.paused-transmission-container {
  border: solid 1px #dc3030;
  background: #ffe0e0;
  border-radius: 16px;
  row-gap: 32px;
}

.error-msg {
  color: #dc3030;
}

.flight-mode-msg {
  background-color: rgba(220, 48, 48, 0.2);
  padding: 12px 18px;
  border-radius: 12px;
  margin-bottom: 1rem;
}

.flight-mode-msg p {
  margin-bottom: 0px;
}

/* ---------- Responsive layout ---------- */

/* Label / value rows inside the info cards: let the value size to its
   content and wrap instead of being squeezed into a fixed col-4. */
.device-info-card .row.mx-2 {
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
}
.device-info-card .row.mx-2 > .col-8 {
  flex: 1 1 auto;
  max-width: none;
  width: auto;
  min-width: 0;
}
.device-info-card .row.mx-2 > .col-4 {
  flex: 0 1 auto;
  max-width: 60%;
  width: auto;
  min-width: 0;
  padding-right: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.last-read-line {
  display: flex;
  flex-wrap: wrap;
}

.map-card {
  min-height: 500px;
}
@media (min-width: 992px) {
  .map-card {
    height: calc(100% - 1.5rem);
  }
}

.history-table-body {
  max-height: 35rem;
  overflow: auto;
}

.chart-card-body {
  min-width: 0;
  max-width: 100%;
  overflow-x: auto;
}

@media (max-width: 767.98px) {
  .map-card {
    min-height: 350px;
  }
  .chart-card-body {
    padding: 1rem 0.75rem;
  }
  .history-table-body {
    padding: 1rem 0.75rem;
  }
  #graphselect {
    padding: 6px 16px;
  }
}

@media (max-width: 575.98px) {
  .device-info-card .card-body {
    padding: 1rem 0.75rem;
  }
  .device-info-card h4 {
    word-break: break-word;
  }
  .start-transmission-btn {
    width: 100%;
  }
  .paused-transmission-container {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
</style>

<i18n>
{
	"en": {
		"add": "Added on",
		"alert": "Alert!",
		"cali": "Calibration Expriry Date",
		"dev-tag": "Device Tag",
		"emp": "Empty",
		"last-read": "Last Read on",
		"no-dev-today": "No Temperature/Humidity data available for today",
		"no-read": "No readings yet",
		"read-on": "Last read on",
		"set-point": "Set Point",
		"sig-strength": "Signal Strength"
	},
	"es": {
		"add": "Añadido",
		"alert": "¡Alerta!",
		"cali": "Date d'expiration de l'étalonnage",
		"dev-tag": "Etiqueta de dispositivo",
		"emp": "vacío",
		"last-read": "Última lectura en",
		"no-dev-today": "No hay datos de temperatura / humedad disponibles para hoy",
		"no-read": "Aún no hay lecturas",
		"read-on": "sigue leyendo",
		"set-point": "Punto fijo",
		"sig-strength": "Intensidad de señal"
	},
	"fr": {
		"add": "Ajouté sur",
		"alert": "alerte!",
		"cali": "Date d'expiration de l'étalonnage",
		"dev-tag": "Balise d'appareil",
		"emp": "vide",
		"last-read": "Dernière lecture",
		"no-dev-today": "Aucune donnée de température/humidité disponible pour aujourd'hui",
		"no-read": "Pas encore de lectures",
		"read-on": "Continuer à lire",
		"set-point": "Point de consigne",
		"sig-strength": "Force du signal"
	},
	"sw": {
		"add": "Imeongezwa",
		"alert": "Tahadhari!",
		"cali": "Tarehe ya Kusafirishwa kwa Urekebishaji",
		"dev-tag": "Lebo ya Kifaa",
		"emp": "tupu",
		"last-read": "Iliyosomwa Mwisho",
		"no-dev-today": "Hakuna data ya Halijoto/Unyevu inayopatikana kwa leo",
		"no-read": "Bado hakuna masomo",
		"read-on": "Iliyosomwa mwisho",
		"set-point": "Weka Pointi",
		"sig-strength": "Nguvu ya Ishara"
	}
}
</i18n>
